import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import { ShareAltOutlined } from "@ant-design/icons";
import { ShareModalContent } from "./ShareModalContent/ShareModalContent";
import { ACCESS_ANYONE, ACCESS_VIEW } from "./shareConstants";
import './ShareModal.css';

const DIALOG_WIDTH = 460;

const DialogHeading = () => (
  <div className="share-modal-heading">
    <span className="share-modal-heading__badge">
      <ShareAltOutlined />
    </span>
    <span className="share-modal-heading__text">
      <span className="share-modal-heading__title">Share</span>
      <span className="share-modal-heading__doc">Invite people or share a link</span>
    </span>
  </div>
);

/** The share dialog alone, for a trigger that lives elsewhere (the header's compact menu). */
export const ShareDialog = ({ open, onClose }) => {
  const [privacy, setPrivacy] = useState(ACCESS_ANYONE);
  const [view, setView] = useState(ACCESS_VIEW);

  // Every way out (the X, the mask, or an action that finishes) reopens on general access.
  const closeDialog = () => {
    onClose();
    setPrivacy(ACCESS_ANYONE);
    setView(ACCESS_VIEW);
  };

  return (
    <Modal
      title={<DialogHeading />}
      open={open}
      onCancel={closeDialog}
      footer={null}
      width={DIALOG_WIDTH}
      centered
      destroyOnClose
      className="share-doc-modal"
    >
      <ShareModalContent onClose={closeDialog} privacy={privacy} setPrivacy={setPrivacy} view={view} setView={setView} />
    </Modal>
  );
};

/** The header's Share button and its dialog. */
export const ShareModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Tooltip title="Share" placement="bottom">
        <button type="button" className="share-trigger" onClick={() => setIsOpen(true)} aria-label="Share">
          <ShareAltOutlined />
          <span className="share-trigger__label">Share</span>
        </button>
      </Tooltip>
      <ShareDialog open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
